import React, { useState } from 'react'
import './LLMResultsDisplay.css'

const LLMResultsDisplay = ({ data }) => {
  const [expandedFields, setExpandedFields] = useState({})

  const toggleField = (index, field) => {
    setExpandedFields((prev) => ({
      ...prev,
      [`${index}-${field}`]: !prev[`${index}-${field}`]
    }))
  }

  return (
    <div className="llm-results-display">
      <h1>Evaluation Results</h1>
      <div className="average-metrics">
        {Object.entries(data.results[0].results).map(([key, value]) => (
          <div key={key} className="average-metric">
            <strong>{key}</strong>: {value.score.toFixed(2)}
          </div>
        ))}
      </div>
      {data.results.map((result, index) => (
        <div key={index} className="result-item">
          <div className="result-field">
            <strong>Input:</strong> {result.input}
          </div>
          <div className="result-field" onClick={() => toggleField(index, 'expected_output')}>
            <strong>Expected Output:</strong>
            {expandedFields[`${index}-expected_output`] ? (
              <p>{result.expected_output}</p>
            ) : (
              <p>{result.expected_output.slice(0, 100)}...</p>
            )}
          </div>
          <div className="result-field" onClick={() => toggleField(index, 'actual_output')}>
            <strong>Actual Output:</strong>
            {expandedFields[`${index}-actual_output`] ? (
              <p>{result.actual_output}</p>
            ) : (
              <p>{result.actual_output.slice(0, 100)}...</p>
            )}
          </div>
          <div className="result-field" onClick={() => toggleField(index, 'retrieval_context')}>
            <strong>Retrieval context:</strong>
            {expandedFields[`${index}-retrieval_context`] ? (
              <p>{result.retrieval_context[0]}</p>
            ) : (
              <p>{result.retrieval_context[0].slice(0, 100)}...</p>
            )}
          </div>
          <div className="result-field" onClick={() => toggleField(index, 'comment')}>
            <strong>User comment:</strong>
            {expandedFields[`${index}-comment`] ? (
              <p>{result.comment || ''}</p>
            ) : (
              <p>{(result.comment || '').slice(0, 100)}...</p>
            )}
          </div>
          <div className="metrics">
            {Object.entries(result.results).map(([key, value]) => (
              <div key={key} className="metric-item">
                <strong>{key}</strong>: {value.score.toFixed(2)}{' '}
                <span className="success-indicator">{value.success ? '✅' : '❌'}</span>
                <p>{value.reason}</p>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  )
}

export default LLMResultsDisplay
